import type { CashbackBonusFormValues, SelectionBonusFormData } from '../schema';

const DEFAULT_BONUS_PER_SELECTION = Array.from({ length: 20 }, (_, i) => ({ value: null }));

export const DEFAULT_SELECTION_BONUS_FORM_DATA: SelectionBonusFormData = {
  name: '',
  product: 'SPORTSBOOK',
  minReqOdd: 1,
  bonusPercentagePerSelection: DEFAULT_BONUS_PER_SELECTION,
  numOfSelectionsBonusEligibility: 'preMatch',
  validityPeriod: 'ONGOING',
  status: 'READY',
  userIds: [],
  description: '',
};

export const DEFAULT_CASHBACK_FORM_DATA = {
  name: '',
  product: 'CASINO',
  eligibility: 'LOST_MONEY_IN_DEFINED_TIMEFRAME',
  validityPeriod: 'ONGOING',
  fromTimestamp: undefined,
  toTimestamp: undefined,
  status: 'READY',
  rewardType: 'REAL_MONEY',
  refundPercentage: 1,
  minimumLostAmount: 0,
  maximumRefundAmount: 0,
  freeSpinTiers: [],
  schedule: 'DAILY',
  userIds: [],
  description: '',
} satisfies CashbackBonusFormValues;
